export const avatarSx = {
  flexShrink: 0,
};

export const selectSx = {
  '&.MuiInputBase-root.Mui-disabled .MuiSelect-select.MuiSelect-select': {
    background: 'none',
  },
};
